import { Stream } from "@cloudflare/stream-react";

const BISHOP_TABET_SERMON_ID = "30a105a709f19dc96bb8c2b73cdf198d";
const BISHOP_TABET_POSTER_URL =
  "https://customer-n5ekme97isdmfb28.cloudflarestream.com/30a105a709f19dc96bb8c2b73cdf198d/thumbnails/thumbnail.jpg?time=5s&width=1280&height=720&fit=clip";

export default function BishopTabet() {
  return (
    <section className="live-funeral" aria-labelledby="bishop-tabet-title">
      <div className="live-funeral__heading">
        <span className="live-funeral__cross" aria-hidden="true">✝</span>
        <p className="live-funeral__kicker">Funeral Homily</p>
        <h1 id="bishop-tabet-title">His Excellency Bishop Paul-Marwan Tabet</h1>
        <p>
          Sermon delivered during Father Paul Oneid&apos;s funeral service in
          Ottawa on October 17, 2026.
        </p>
      </div>

      <section className="live-funeral__recording" aria-labelledby="bishop-tabet-recording-title">
        <div className="live-funeral__section-heading">
          <p className="live-funeral__section-label">Recorded Sermon</p>
          <h2 id="bishop-tabet-recording-title">His Excellency Bishop Paul-Marwan Tabet</h2>
        </div>

        <div className="live-funeral__player">
          <Stream
            controls
            src={BISHOP_TABET_SERMON_ID}
            poster={BISHOP_TABET_POSTER_URL}
            responsive
            preload="metadata"
            autoplay={false}
            muted={false}
            primaryColor="#7d3f75"
            letterboxColor="#2e1c29"
            title="His Excellency Bishop Paul-Marwan Tabet sermon"
          />
        </div>

        <div className="live-funeral__document">
          <p>Read the complete Arabic text of Bishop Tabet&apos;s sermon.</p>
          <a
            className="live-funeral__document-link"
            href="/media/sermons/bishop-tabet-sermon-arabic.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Sermon Script (Arabic PDF)</span>
            <span lang="ar" dir="rtl">قراءة نص كلمة سيادة المطران تابت</span>
          </a>
        </div>
      </section>

      <div className="live-funeral__guidance">
        <h2>Watching the sermon</h2>
        <ul>
          <li>Press the play button and turn on your sound.</li>
          <li>You may pause, resume, or move to any part of the sermon.</li>
          <li>A stable Wi-Fi or wired internet connection is recommended.</li>
        </ul>
      </div>
    </section>
  );
}
